import { defineMessages } from 'react-intl';

export default defineMessages({
    verbalAuthorization: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Verbal Authorization',
        defaultMessage: 'Verbal Authorization'
    },
    disclaimer: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Disclaimer',
        defaultMessage: 'Disclaimer'
    },
    requiredSignatures: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Required Signatures',
        defaultMessage: 'Required Signatures'
    },
    updatingForms: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Updating forms',
        defaultMessage: 'Updating forms...'
    },
    documents: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Documents',
        defaultMessage: 'Documents'
    },
    yourDocuments: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.your documents',
        defaultMessage: 'your documents'
    },
    requiredForms: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.required forms',
        defaultMessage: 'required forms'
    },
    completeYourPurchase: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.complete your purchase',
        defaultMessage: 'complete your purchase'
    },
    bundleCart: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.bundle cart',
        defaultMessage: 'bundle cart'
    },
    verbalAuthorizationNextDescription: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.verbalAuthorizationNextDescription',
        defaultMessage: 'We\'ll review additional {requiredForms} next'
    },
    requiredSignatureNextDescription: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.requiredSignatureNextDescription',
        defaultMessage: 'We\'ll review {yourDocuments} next'
    },
    availableDocumentsNonBundledNextDescription: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.availableDocumentsNonBundledNextDescription',
        defaultMessage: 'We\'ll {completeYourPurchase} next'
    },
    availableDocumentsBundledNextDescription: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.availableDocumentsBundledNextDescription',
        defaultMessage: 'You\'ll review your {bundleCart} next'
    },
    issuePolicy: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Issue Policy',
        defaultMessage: 'Issue Policy'
    },
    applySignature: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Apply signature',
        defaultMessage: 'Apply signature type to all items?'
    },
    applySignatureToAll: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.applySignatureToAll',
        defaultMessage: 'Do you want to apply this signature type to all items in the list?'
    },
    processingPayment: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Processing Payment...',
        defaultMessage: 'Processing Payment...'
    },
    invalidEmail:{
        id:'ml.gateway.quoteandbind.common.AgentSignatureOptions.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    somethingWentWrong: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    paymentMismatchError: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.paymentMismatchError',
        defaultMessage: 'We\'ve detected a change in the payment method. To ensure accurate rating, you’ll need to requote before issuing this policy. '
    },
    returnToQuote: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.Return to Quote',
        defaultMessage: 'Return to Quote'
    },
    paymentError: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.paymentError',
        defaultMessage: 'Error when trying to make payment. Please try again or contact us by chat or call customer service at 1-800-255-0332'
    },
    invalidMobile: {
        id: 'ml.gateway.quoteandbind.common.AgentSignatureOptions.invalidMobileError',
        defaultMessage: 'Mobile number is invalid. Please enter valid mobile number'
    }
})